export default __webpack_public_path__ + "static/ProductGraphic3-1a99d75864573601c39d7346e775267c.png";